import { render, staticRenderFns } from "./PromocodeForm.vue?vue&type=template&id=e904ab5c&scoped=true&"
import script from "./PromocodeForm.vue?vue&type=script&lang=js&"
export * from "./PromocodeForm.vue?vue&type=script&lang=js&"
import style0 from "./PromocodeForm.vue?vue&type=style&index=0&id=e904ab5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e904ab5c",
  null
  
)

export default component.exports